import { Music4 } from "lucide-react";
import { coverUrl } from "@/context/PlayerContext";

export const BeatCover = ({ beat, className = "h-11 w-11", testId }) => {
  const url = coverUrl(beat);
  return url ? (
    <img src={url} alt={`${beat.title} cover`} data-testid={testId} className={`${className} object-cover shrink-0`} />
  ) : (
    <div data-testid={testId} className={`${className} shrink-0 flex items-center justify-center bg-gradient-to-br from-[#2A0509] to-[#0D0D0D] border border-[#D90429]/30`}>
      <Music4 className="h-4 w-4 text-[#D90429]" strokeWidth={1.5} />
    </div>
  );
};
